import { ILabelValuePair } from './shared';
import { IAddressInputFields, IAddressFieldInfo, IDOB } from './types';

export const metaGroupTypes = ['address', 'currency_amount', 'table'] as const;
export type MetaGroupTypes = typeof metaGroupTypes[number];

export const metaAddressGroupRoles = [
  'address1',
  'address2',
  'city',
  'state_province',
  'country',
  'postal_code',
] as const;
export type MetaAddressGroupRoles = typeof metaAddressGroupRoles[number];

export const metaCurrencyAmountGroupRoles = ['currency', 'amount'] as const;
export type MetaCurrencyAmountGroupRoles = typeof metaCurrencyAmountGroupRoles[number];

export const metaTableGroupRoles = ['summary', 'detail'] as const;
export type MetaTableGroupRoles = typeof metaTableGroupRoles[number];

export type MetaGroupRoles = MetaAddressGroupRoles | MetaCurrencyAmountGroupRoles | MetaTableGroupRoles;

export interface IAllSectionFieldValues {
  [sectionName: string]: {
    [fieldName: string]: string | number | string[] | number[] | IDOB | IAddressInputFields | null;
  };
}

export interface IFNOLValues {
  sectionFields: IAllSectionFieldValues;
}

export interface IClaimSelectorAnswersValues {
  [claimSelectorAnswerName: string]: string;
}

export interface IAllClaimAnswersValues {
  [bookingID: string]: {
    sectionFields: IAllSectionFieldValues;
    claimSelectorAnswers: IClaimSelectorAnswersValues;
    savedTime?: string;
  };
}

export interface ISectionFieldCondition {
  section: string;
  field: string;
  operator: string;
  value: number | string | number[] | string[];
}

export interface ISectionFieldMetaGroup {
  name: string;
  role: MetaGroupRoles;
  type: MetaGroupTypes;
}

export interface ISectionField {
  id: string;
  name: string;
  type:
    | 'string'
    | 'email'
    | 'date'
    | 'datetime'
    | 'numeric'
    | 'url'
    | 'boolean'
    | 'enum'
    | 'geolocation'
    | 'file'
    | 'set'
    | 'country'
    | 'currency'
    | 'currencyAmount' // custom type
    | 'FNOLAddress' // custom type
    | 'dob'; // custom type
  required: boolean;
  readOnly: boolean;
  validation?: {
    length?: {
      min: number;
      max: number;
    };
    numeric?: {
      min: number;
      max: number;
    };
    multiselect?: {
      min: number;
      max: number;
    };
    float?: any;
  } | null;
  options?: ILabelValuePair[] | null;
  meta?: {
    label: string;
    description?: string;
    placeholder?: string;
    display?: string;
    group?: ISectionFieldMetaGroup;
  };
  ordering: number;
  conditions: ISectionFieldCondition[] | null;
  nameList?: IAddressFieldInfo<string>;
  labelList?: IAddressFieldInfo<string | undefined>;
  descriptionList?: IAddressFieldInfo<string | undefined>;
  placeholderList?: IAddressFieldInfo<string | undefined>;
  requiredList?: IAddressFieldInfo<boolean>;
  bundledCurrencyFieldName?: string;
}

export interface IFNOLSection {
  id: string;
  name: string;
  label: string;
  description?: string;
  ordering: number;
  sectionFields: ISectionField[];
}

export interface IAllSectionFields {
  [sectionName: string]: {
    [fieldName: string]: ISectionField;
  };
}

export interface IFNOLSubmittedRouterState {
  amountPaidFormatted?: string;
  isFromEmail?: boolean;
  isPaymentError?: boolean;
  chargeCurrency?: string;
  isExcessSkipped?: boolean;
}

export interface IFNOLExcessRouterState {
  chargeID: string;
  chargeToken: string;
  chargeCurrency: string;
  chargeAmountFormatted: string;
}

export interface IGroupedFields {
  fields: ISectionField[];
  type: MetaGroupTypes | 'non_group_fields';
  name?: string | 'non_group_fields';
}

export interface IClaimErrors {
  displayGeneralErrorMessage: boolean;
}
